export enum CursorPosition {
    Left,
    Right,
    Middle,
    Hidden,
}
